import type { DisplayTemplateRule } from './moving-item.types';

export interface ValidateDisplayTemplateRulesResult {
  valid: boolean;
  message?: string;
  firstErrorIndex?: number;
}

/**
 * displayTemplateRules 클라이언트 검증 (서버 MOVING_009 / MovingItemDisplayTemplateRulesValidator와 정렬).
 * - 빈 배열은 유효합니다.
 * - 마지막 행은 반드시 ALWAYS_MATCH (서버와 동일).
 * - 그 위 행은 최상위 leaf(Number*, BooleanEq, EnumIn 등) 단독 허용.
 */
export function validateDisplayTemplateRules(
  rules: DisplayTemplateRule[] | undefined
): ValidateDisplayTemplateRulesResult {
  const list = rules ?? [];
  if (list.length === 0) {
    return { valid: true };
  }

  const last = list[list.length - 1];
  if (last.rule.type !== 'ALWAYS_MATCH') {
    return {
      valid: false,
      message: '마지막 규칙은 반드시 "항상 참(AlwaysMatch)"이어야 합니다.',
      firstErrorIndex: list.length - 1,
    };
  }

  return { valid: true };
}
